// Empresa (sucursal) elegida en Principal, guardada por usuario para que cada
// sistema contable recuerde la suya al recargar la página.

const LEGACY_KEY = 'cs';

function userKey() {
	try {
		const user = JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::adminUser`)) || {};
		const id = user.code_user || user.email || user.id;
		return id ? `cs::${id}` : LEGACY_KEY;
	} catch (error) {
		return LEGACY_KEY;
	}
}

function read() {
	try {
		const subsidiary = JSON.parse(localStorage.getItem(userKey()));
		return subsidiary && subsidiary.id ? subsidiary : null;
	} catch (error) {
		return null;
	}
}

function write(subsidiary) {
	const value = JSON.stringify(subsidiary || {});
	localStorage.setItem(userKey(), value);
	// Algunas pantallas todavía leen 'cs' directamente.
	localStorage.setItem(LEGACY_KEY, value);
}

function clear() {
	localStorage.removeItem(userKey());
	localStorage.removeItem(LEGACY_KEY);
}

// Límite de empresas del plan (subsidiaries_limit). null = sin límite.
// `remote` es el límite propio de la compañía (GET company-plan); si no se pudo
// consultar (undefined) se usa el del plan de la sesión.
function planLimit(userInfo, remote) {
	if (remote !== undefined) return remote;
	try {
		const user = typeof userInfo === 'string' ? JSON.parse(userInfo) : userInfo;
		const acl = (user && user.companyAcl) || {};
		let plan = acl.plan || acl.selectPlans;
		if (Array.isArray(plan)) [plan] = plan;
		const limit = Number(plan && plan.subsidiaries_limit);
		return Number.isFinite(limit) && limit > 0 ? limit : null;
	} catch (error) {
		return null;
	}
}

// Si la cuenta tiene más empresas que las que permite el plan, solo se pueden
// usar las más antiguas hasta el límite; el resto queda bloqueado.
function allowedIds(subsidiaries, userInfo, remote) {
	const list = subsidiaries || [];
	const limit = planLimit(userInfo, remote);
	const ordered = list.slice().sort((a, b) => Number(a.id) - Number(b.id));
	const allowed = limit === null ? ordered : ordered.slice(0, limit);
	return new Set(allowed.map(item => Number(item.id)));
}

function isAllowed(subsidiary, subsidiaries, userInfo, remote) {
	return !!subsidiary && allowedIds(subsidiaries, userInfo, remote).has(Number(subsidiary.id));
}

// Límite propio de la compañía en comercial; undefined si no se pudo consultar.
async function fetchRemoteLimit(http) {
	try {
		const { data } = await http.get('company-plan');
		// Sin plan en comercial se usa el de la sesión.
		if (!data || !data.found) return undefined;
		const limit = Number(data.subsidiariesLimit);
		return Number.isFinite(limit) && limit > 0 ? limit : null;
	} catch (error) {
		return undefined;
	}
}

export default {
	allowedIds,
	clear,
	fetchRemoteLimit,
	isAllowed,
	planLimit,
	read,
	write,
};



// WEBPACK FOOTER //
// ./src/shared/current-subsidiary.js